<template>
    <div>
        <b-container class="container-panel">
            <b-row align-v="end">
                <b-row class="p-1" align-v="end">
                    <b-col cols="4">
                        <img src="@/assets/logo-small.jpg"
                             class="logo-margin"
                             alt="Ambit Logo"
                             aria-label="Ambit Logo" />
                    </b-col>
                </b-row>
                <b-col cols="8">
                    <span class="page-title align-center">{{$t('VERIFYING')}}</span>
                </b-col>
            </b-row>
        </b-container>
        <b-container>
            <b-row>
                <b-col cols="12"
                       class="d-flex justify-content-center mb-3 make-space-above ambit-orange">
                    <b-spinner></b-spinner>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import AmbitLogo from '../components/AmbitLogo.vue';
import Repo from '../repo';

export default {
    name: "BluenetPaymentMethods",
    components: {AmbitLogo},
    data: () => ({agent: ""}),
    mounted(){
        this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
        Repo.AuthenticationService.ValidateToken({Token: this.$route.params.authToken }).then(res => {
            if (res && res.success) {
                this.agent = res.userId;
                this.validateAccountInfo().then(isValid => {
                    if (isValid) {
                        this.redirect();
                    }
                })
            } else {
                this.$store.dispatch('shell/addErrorMessages', i18n.t('NOT_AUTHENTICATED'));
            }
        })
    },
    methods: {
        validateAccountInfo: async function () {
            var req = { ANumber: this.$route.params.aNumber, CustomerNumber: this.$route.params.customerNumber };
            return this.$store.dispatch('lobby/getCustomerName', req);
        },
        redirect: async function () {
            var additionalParameters = Object.assign(
                {},
                {
                    Agent: this.agent,
                    CustomerNumber: this.$route.params.customerNumber,
                    DialogId: this.$route.query.dialogId
                }
            );
            var body = Object.assign(
                {},
                {
                    ExternalKeyValue: this.$route.params.aNumber,
                    ExternalKeyType: "CUSTOMER",
                    PaymentCampaignCode: "BLUENET",
                    CountryCode: "US",
                    DisplayLanguageOptions: ["en", "sp"],
                    CallBackUrl: this.$route.query.CallBackUrl,
                    AdditionalParameters: additionalParameters
                }
            );
            this.$store.dispatch("lobby/getPaymentMethodToken", body);
        }
    }
};
</script>
